import { Component, Prop, h, Host, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'dda-checkbox',
  styleUrls: ['dda-checkbox.css'],
  shadow: false,
})
export class DdaCheckbox {
  @Prop() title_text: string;
  @Prop() supporting?: string;
  @Prop() group_name?: string;
  @Prop() input_id?: string;
  @Prop() checked: boolean;
  @Prop() checkbox_status?: string;
  @Prop() style_type?: string;
  @Prop() custom_class?: string = ''; 
  @Prop() component_mode?: string; 
  @Prop() aria_label?: string;

  /** Emits change event with current checked state */
  @Event() checkboxChange: EventEmitter<boolean>;

  /** Handles checkbox change */
  handleInputChange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    this.checkboxChange.emit(target.checked);
  };

  render() {
    const checkboxClass = [
      'dda-checkbox-container',
      this.style_type ? `dda-checkbox-${this.style_type}` : '',
      this.custom_class ? this.custom_class : '',
      this.checkbox_status ? `dda-checkbox-${this.checkbox_status}` : '',
      this.component_mode,
    ].filter(Boolean).join(' ');

    return (
      <Host>
        <div class={checkboxClass}>
          <input
            type="checkbox"
            id={this.input_id}
            name={this.group_name}
            aria-label={this.aria_label}
            checked={this.checked}
            onChange={this.handleInputChange}
          />
          <label htmlFor={this.input_id}>
            <span class="dda-check-square"></span>
            <p>
              <span class="dda-checkbox-title">{this.title_text}</span>
              {this.supporting && (
                <span class="dda-checkbox-supporting">{this.supporting}</span>
              )}
            </p>
          </label>
        </div>
      </Host>
    );
  }
}
